<form [formGroup]="form" class="d-grid gap-2">
  <div>
    <label for="name" class="form-label">Name</label>
    <input type="text" id="name" formControlName="name" class="form-control"
      [class.is-invalid]="name.invalid && name.touched">
      @if (name.invalid) {
        <div class="invalid-feedback">Name is required.</div>
      }
    </div>
  </form>